export enum ResourceKind {
    BusinessAccount = 'businessAccount',
    BrandsStrategy = 'brandsStrategy',
    BrandsAudience = 'brandsAudience',
    BrandsCampaign = 'brandsCampaign',
    BrandsPhase = 'brandsPhase',
    ContentLibraryContentTag = 'contentLibraryContentTag',
    ContentLibraryHeadlineItem = 'contentLibraryHeadlineItem',
    ContentLibraryImageItem = 'contentLibraryImageItem',
    ContentLibraryMessageItem = 'contentLibraryMessageItem',
    ContentLibraryVideoItem = 'contentLibraryVideoItem',
    KomboIntegration = 'komboIntegration',
    JobCampaign = 'jobCampaign',
    JobGroupImporterSetting = 'jobGroupImporterSetting',
    JobGroupImporterConfig = 'jobGroupImporterConfig',
    JobGroup = 'jobGroup',
    Talent = 'talent',
    LeadsConversation = 'leadsConversation',
    TalentMessage = 'talentMessage',
    Channel = 'channel',
    Journey = 'journey',
    ProductItem = 'productItem',
    Role = 'role',
    Talentpool = 'talentpool',
    TalentStatuses = 'talentStatuses',
    User = 'user',
}

const resourceKindToResourcePathMap = new Map<ResourceKind, string>([
    [ResourceKind.BusinessAccount, '/business-accounts'],
    [ResourceKind.BrandsStrategy, '/brands-strategy'],
    [ResourceKind.BrandsAudience, '/brands-audiences'],
    [ResourceKind.BrandsCampaign, '/brands-campaigns'],
    [ResourceKind.BrandsPhase, '/brands-phases'],
    [ResourceKind.ContentLibraryContentTag, '/content-library/content-tags'],
    [ResourceKind.ContentLibraryHeadlineItem, '/content-library/headline-items'],
    [ResourceKind.ContentLibraryImageItem, '/content-library/image-items'],
    [ResourceKind.ContentLibraryMessageItem, '/content-library/message-items'],
    [ResourceKind.ContentLibraryVideoItem, '/content-library/video-items'],
    [ResourceKind.KomboIntegration, '/kombo-integrations'],
    [ResourceKind.JobCampaign, '/job-campaigns'],
    [ResourceKind.JobGroupImporterSetting, '/job-group-importer-settings'],
    [ResourceKind.JobGroupImporterConfig, '/job-group-importer-configs'],
    [ResourceKind.JobGroup, '/job-groups'],
    [ResourceKind.Talent, '/talents'],
    [ResourceKind.LeadsConversation, '/leads-conversations'],
    [ResourceKind.TalentMessage, '/talent-messages'],
    [ResourceKind.Channel, '/channels'],
    [ResourceKind.Journey, '/journeys'],
    [ResourceKind.ProductItem, '/product-items'],
    [ResourceKind.Role, '/roles'],
    [ResourceKind.Talentpool, '/talentpools'],
    [ResourceKind.TalentStatuses, '/talent-statuses'],
    [ResourceKind.User, '/users'],
]);

export const getResourcePathByResourceKind = (resourceKind: ResourceKind): string | undefined =>
    resourceKindToResourcePathMap.get(resourceKind);
